export const geosMap = [
  {value: 'cities', label: 'Cidade', type: 'Geo::City'}, 
  {value: 'groups', label: 'Grupo Geográfico', type: 'Geo::Group'},
  {value: 'countries', label: 'País', type: 'Geo::Country'}, 
  {value: 'regions', label: 'Região', type: 'Geo::Region'}, 
  {value: 'states', label: 'Estado', type: 'Geo::State'},
]
